import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OnboardGuard } from './shared/guards/onboard.guard';
import { TermoGuard } from './shared/guards/termo.guard';
import {PainelResolve} from './shared/services/painel.resolve';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'painel',
    canLoad: [OnboardGuard]
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingPageModule)
  },
  {
    path: 'termo',
    loadChildren: () => import('./termo/termo.module').then( m => m.TermoPageModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    canLoad: [OnboardGuard, TermoGuard]
  },
  {
    path: 'definicoes',
    loadChildren: () => import('./definicoes/definicoes.module').then( m => m.DefinicoesPageModule),
    canLoad: [OnboardGuard, TermoGuard]
  },
  {
    path: 'painel',
    loadChildren: () => import('./painel/painel.module').then( m => m.PainelPageModule),
    resolve: {estacoes: PainelResolve},
    canLoad: [OnboardGuard, TermoGuard]
  },
  {
    path: 'notificacoes',
    loadChildren: () => import('./notificacoes/notificacoes.module').then( m => m.NotificacoesPageModule),
    canLoad: [OnboardGuard, TermoGuard]
  },
  {
    path: 'mapa',
    loadChildren: () => import('./mapa/mapa.module').then( m => m.MapaPageModule),
    canLoad: [OnboardGuard, TermoGuard]
  },
  {
    path: 'estacao',
    loadChildren: () => import('./mapa/estacao/estacao.module').then( m => m.EstacaoPageModule),
    canLoad: [OnboardGuard, TermoGuard]
  },
  {
    path: 'painel/estacoes-favoritas',
    loadChildren: () => import('./painel/estacoes-favoritas/estacoes-favoritas.module').then(m => m.EstacoesFavoritasModule)
  },
  {
    path: 'widget/qualidade-ar',
    pathMatch: 'full',
    loadChildren: () => import('./widget/qualidade-ar/qualidade-ar-widget.module').then(m => m.QualidadeArWidgetModule)
  },
  {
    path: 'widget/estacoes-favoritas/:idAplicativo/:tamanho',
    pathMatch: 'full',
    loadChildren: () => import('./widget/estacoes-favoritas/estacoes-favoritas-widget.module').then(m => m.EstacoesFavoritasWidgetModule)
  },
  {
    path: 'widget/estacoes-proximas/:idAplicativo/:tamanho',
    pathMatch: 'full',
    loadChildren: () => import('./widget/estacoes-proximas/estacoes-proximas-widget.module').then(m => m.EstacoesProximasWidgetModule)
  },
  {
    path: 'documentos',
    loadChildren: () => import('./documentos/documentos.module').then( m => m.DocumentosPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
